import React, { useState } from 'react';
import '../styles/LetterDrag.css';

const LetterDrag = () => {
    const [letters, setLetters] = useState(['O', 'H', 'N', 'A', 'J', 'T', 'N', 'A']);
    const [draggedIndex, setDraggedIndex] = useState(null);

    const handleDragStart = (index) => (event) => {
        setDraggedIndex(index);
        event.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (index) => (event) => {
        event.preventDefault();
    };

    const handleDrop = (index) => (event) => {
        event.preventDefault();
        if (draggedIndex === null) return;

        const newLetters = [...letters];
        const [removed] = newLetters.splice(draggedIndex, 1);
        newLetters.splice(index, 0, removed);
        setLetters(newLetters);
        setDraggedIndex(null);
    };

    return (
        <div className="letter-drag-container">
        {letters.map((letter, index) => (
            <span
            key={index}
            draggable
            onDragStart={handleDragStart(index)}
            onDragOver={handleDragOver(index)}
            onDrop={handleDrop(index)}
            className="draggable-letter"
            >
            {letter}
            </span>
        ))}
        </div>
    );
};

export default LetterDrag;
